import {
  MainPhotoSection,
  IncreaseSection,
} from "../../MainPage/MainPageStyles";
import {
  ArrangementSection,
  FeaturesStockTradingSection,
  ProsCostSection,
  LinksSections,
} from "./FundamentalsStyles";
import FundamentalMainPhoto from "../../../images/fundamentalMainPhoto.png";
import { NavLink } from "react-router-dom";
import LaptopPhoto from "../../../images/laptop__photo.png";
import { motion } from "framer-motion";
import {
  animationFromTheSide,
  arrAnimation,
  mainAnimation,
} from "../../../animations/animations";
import { MTermsCard } from "../../../components/Cards/TermsCard/TermsCard";
import PriceIcon from "../../../images/CardsImages/FundamentalsTradingIcons/price.svg";
import CommissionIcon from "../../../images/CardsImages/FundamentalsTradingIcons/commission.svg";
import ProfitableIcon from "../../../images/CardsImages/FundamentalsTradingIcons/profitable.svg";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/hooks";
import { generateLink } from "../../../functions/routingFuntion";

export const Fundamentals = () => {
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  return (
    <main>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("fundamentalsPage.title1")}</h1>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={FundamentalMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <ArrangementSection>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("fundamentalsPage.blockInfo1Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="arrangement-section__content flex__between"
          >
            <motion.div custom={1} variants={arrAnimation}>
              {t("fundamentalsPage.blockInfo11")}
            </motion.div>
            <motion.div custom={2} variants={arrAnimation}>
              {t("fundamentalsPage.blockInfo12")}
            </motion.div>
          </motion.div>
        </div>
      </ArrangementSection>
      <FeaturesStockTradingSection>
        <div className="container__standart">
          <div className="top__content">
            <motion.h2
              initial="hidden"
              whileInView="visible"
              viewport={{ amount: 0.3, once: true }}
              variants={animationFromTheSide}
            >
              {t("fundamentalsPage.blockInfo2Tit")}
            </motion.h2>
            <div className="flex__between">
              <p>{t("fundamentalsPage.blockInfo21")}</p>
              <p>{t("fundamentalsPage.blockInfo22")}</p>
            </div>
          </div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="cards flex__between"
          >
            <MTermsCard
              img={ProfitableIcon}
              title={`${t("fundamentalsPage.blockInfo31")}`}
              custom={1}
              variants={arrAnimation}
            />
            <MTermsCard
              img={CommissionIcon}
              title={`${t("fundamentalsPage.blockInfo32")}`}
              custom={2}
              variants={arrAnimation}
            />
            <MTermsCard
              img={PriceIcon}
              title={`${t("fundamentalsPage.blockInfo33")}`}
              custom={3}
              variants={arrAnimation}
            />
          </motion.div>
        </div>
      </FeaturesStockTradingSection>
      <ProsCostSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          variants={mainAnimation}
          className="container__standart"
        >
          <h2>{t("fundamentalsPage.blockInfo4Tit")}</h2>
          <p>{t("fundamentalsPage.blockInfo41")}</p>
          <p>{t("fundamentalsPage.blockInfo42")}</p>
          <div className="pros-cost__cards flex__between">
            <div>
              <h4>{t("fundamentalsPage.blockInfo5Tit")}</h4>
              <span></span>
              <ul>
                <li>{t("fundamentalsPage.blockInfo5li1")}</li>
                <li>{t("fundamentalsPage.blockInfo5li2")}</li>
                <li>{t("fundamentalsPage.blockInfo5li3")}</li>
              </ul>
            </div>
            <div>
              <h4 className="red__title">
                {t("fundamentalsPage.blockInfo6Tit")}
              </h4>
              <span className="red__span"></span>
              <ul>
                <li>{t("fundamentalsPage.blockInfo6li1")}</li>
                <li>{t("fundamentalsPage.blockInfo6li2")}</li>
                <li>{t("fundamentalsPage.blockInfo6li3")}</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </ProsCostSection>
      <section>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("fundamentalsPage.blockInfo7Tit")}
          </motion.h2>
        </div>
      </section>
      <LinksSections>
        <div className="container__standart">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="links-section__content flex__between"
          >
            <motion.div custom={1} variants={arrAnimation}>
              <p>{t("fundamentalsPage.blockInfo711")}</p>
              <NavLink to={generateLink("/trade/analysis", language)}>
                {t("fundamentalsPage.blockInfo712")}
              </NavLink>
            </motion.div>
            <motion.div custom={2} variants={arrAnimation}>
              <p>{t("fundamentalsPage.blockInfo721")}</p>
              <NavLink to={generateLink("/trade/tehnical-analysis", language)}>
                {t("fundamentalsPage.blockInfo722")}
              </NavLink>
            </motion.div>
          </motion.div>
        </div>
      </LinksSections>
      <IncreaseSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="flex__between container__standart"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("fundamentalsPage.blockInfo8Tit")}</h2>
            <NavLink
              className="white__button flex__center"
              to={generateLink("/auth/register", language)}
            >
              {t("fundamentalsPage.blockInfo81")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <img src={LaptopPhoto} alt="LaptopPhoto" />
          </motion.div>
        </motion.div>
      </IncreaseSection>
    </main>
  );
};
